import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface PageMeta {
  title: string;
  helpText?: string;
}

interface PageContextValue {
  meta: PageMeta;
  setPageMeta: (meta: PageMeta) => void;
}

const PageContext = createContext<PageContextValue>({
  meta: { title: "" },
  setPageMeta: () => {},
});

export function PageProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<PageMeta>({ title: "" });
  const setPageMeta = useCallback((m: PageMeta) => setMeta(m), []);
  return (
    <PageContext.Provider value={{ meta, setPageMeta }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageMeta() {
  return useContext(PageContext);
}
